import { render, staticRenderFns } from "./GifSticker.vue?vue&type=template&id=952882c2&"
import script from "./GifSticker.vue?vue&type=script&lang=js&"
export * from "./GifSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports